import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from 'src/app/providers/modal-service/ModalService';
import { ConfigService } from 'src/app/providers/config/config.service';
import { Router } from '@angular/router';
import { CurrencyFormatterPipe } from 'src/app/pipes/currency-formatter.pipe';
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-bonus-alert',
  templateUrl: './bonus-alert.component.html',
  styleUrls: ['./bonus-alert.component.scss']
})
export class BonusAlertComponent implements OnInit, AfterViewInit, OnDestroy{
  @ViewChild('bonusBody') bonusBody!: ElementRef;
  bonuses: any[];
  bonusMsg: any;
  subscription: Subscription = new Subscription();
  @Output() close = new EventEmitter<{type: string}>();
  constructor(
    private renderer: Renderer2,
    public sanitizer: DomSanitizer,
    private modalService: ModalService,
    private currencyPipe: CurrencyFormatterPipe,
    private router: Router,
    private elementRef: ElementRef,
    private config: ConfigService,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      $('#bonusAlert').modal('show');
    }, 300);

  }

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.querySelector('#bonusDialog').contains(targetElement);
    if (!clickedInside) {
      this.onCloseDialog();
    }
  }

  ngAfterViewInit(): void {
    this.bonusBody.nativeElement.innerHTML = this.bonusBody.nativeElement.innerHTML.replace(/(\r\n|\n|\r)/g, "");
    const title = this.bonusBody.nativeElement.querySelector('.title');
    const subTitle = this.bonusBody.nativeElement.querySelector('.sub-title');
    const bonusList = this.bonusBody.nativeElement.querySelector('.list-group-flush');

    if(title && subTitle){
      const c1: string = title.textContent.trim() || '';
      const c2: string = subTitle.textContent.trim() || '';
      const [msg, bonus] = c2.split(':');

      const paragraph = this.renderer.createElement('p');
      const text1 = this.renderer.createText(`${c1} ${msg.trim()} :`);
      this.renderer.appendChild(paragraph, text1);
      if(bonus){
        const br = this.renderer.createElement('br');
        this.renderer.appendChild(paragraph, br);
        const strong = this.renderer.createElement('strong');
        let bonusText = bonus.trim().split(' ');
        let amount = bonusText.pop();
        const strongText = this.renderer.createText(`${bonusText.join(' ')} ${this.currencyPipe.transform(amount, true)}`);
        this.renderer.appendChild(strong, strongText);
        this.renderer.appendChild(paragraph, strong);
      }

      const mainContainer = this.bonusBody.nativeElement.querySelector('.headings.sticky');

      if (mainContainer) {
          this.renderer.removeChild(this.bonusBody, mainContainer);
      }

      this.renderer.appendChild(this.bonusBody.nativeElement, paragraph);
    }

    if(bonusList){
      this.renderer.appendChild(this.bonusBody.nativeElement, bonusList);
      const mainBonus = this.bonusBody.nativeElement.querySelector('.bonus-details');

      if (mainBonus) {
          this.renderer.removeChild(this.bonusBody, mainBonus);
      }
    }

    this.subscription.add(
      this.modalService.closeAll$.subscribe((close) => {
        if(close){
          this.onCloseDialog();
          this.modalService.closeAll$.next(false);
        }
      })
    );
  }

  onCloseDialog(){
    // this.dialogRef.close(this.data);
    // this.skeleton.closeCDKModal();
    $('#bonusAlert').modal('hide');
    this.close.emit({type: 'bon-alert'})
  }

  onOpenBonuses(){
    this.router.navigate(['/profile/bonuses']);
    this.onCloseDialog();
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }

}
